import { useWeb3React } from "@web3-react/core";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import { BsFacebook } from "react-icons/bs";
import { FaHandSparkles } from "react-icons/fa";
import { HiLink } from "react-icons/hi";
import { TbHandClick, TbHandFinger } from "react-icons/tb";
import { BiMessageSquareDetail } from "react-icons/bi";

import LinkWithSearchParams from "../Components/UI/LinkWithSearchParams";
import LoadingBar from "../Components/UI/LoadingBar";
import {
    getPostByLink,
    getReplyAuthors,
    likeArticle,
    replyArticle,
} from "../utils/apis";
import { notify, showToast, walletConnectNotify } from "../utils/hot-toast";

import MDEditor from "@uiw/react-md-editor";
import { GiChainedHeart } from "react-icons/gi";
import ProfileBadge from "../Components/UI/ProfileBadge";
import { useStore } from "../utils/store";
import Web3 from "web3";
import HoverGiphy from "../Components/UI/HoverGiphy";
import { AiOutlineGif } from "react-icons/ai";
import { RiDeleteBin2Line } from "react-icons/ri";
import { getEllipsisTxt } from "../helpers/formatters";

const ViewPost = () => {
    const { link } = useParams();
    const { account, library } = useWeb3React();
    const [mainLoading, setMainLoading] = useState(false);
    const [postDetails, setPostDetails] = useState(null);
    const [replyAuthors, setReplyAuthors] = useState([]);

    const profile = useStore((state) => state.profile);
    const followOthersProfile = useStore((state) => state.followOthersProfile);

    const [replyMarkdown, setReplyMarkdown] = useState("");
    const [giphyLink, setGiphyLink] = useState("");

    useEffect(() => {
        if (link) loadPost();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [link]);
    const loadPost = async () => {
        setMainLoading(true);
        const _postDetails = await getPostByLink(link);

        if (_postDetails) {
            setPostDetails(_postDetails);
            setMainLoading(false);
            loadReplyAuthors(_postDetails);
            return;
        } else setPostDetails(null);
        setMainLoading(false);
        console.log("error", _postDetails);
    };
    const loadReplyAuthors = async (_postDetails) => {
        if (!_postDetails) return;
        const _replyAuthors = await getReplyAuthors(_postDetails.post._id);
        if (_replyAuthors) setReplyAuthors(_replyAuthors);
    };

    const replyAuthor = (wallet) => {
        if (!replyAuthors) return null;
        return replyAuthors.find((author) => author.wallet === wallet);
    };

    const likeToggleArticle = async (id) => {
        if (!account) {
            walletConnectNotify();
            return;
        }
        try {
            const _updatedPost = await likeArticle(id, account);
            setPostDetails({ ...postDetails, post: _updatedPost });
            if (_updatedPost.likes.includes(account)) {
                notify(
                    "success",
                    <FaHandSparkles className="w-16 h-16 animation-enter" />,
                    "Like Post!",
                    "Successfully clapped this article"
                );
                return;
            }
            showToast("info", "Successfully unclapped this article.", null);
        } catch (error) {
            showToast(
                "error",
                "Error occured while clapping article.",
                null,
                "Something went wrong!"
            );
        }
    };

    const onGifClick = (gif, e) => {
        e.preventDefault();
        if (gif?.images?.original?.webp) {
            setGiphyLink(gif?.images?.original?.webp);
            // onBlurMarkdown();
        }
    };

    const onPostReply = async () => {
        window.web3 = new Web3(library?.provider);
        const web3 = window.web3;
        try {
            if (!web3 || replyMarkdown.trim().length === 0) return;

            const signatureHash = await web3.eth.personal.sign(
                postDetails?.post?.link,
                profile.wallet
            );

            const result = await replyArticle(
                profile?.wallet,
                postDetails?.post?._id,
                replyMarkdown,
                giphyLink,
                signatureHash
            );
            if (result?.createdAt) {
                setPostDetails({
                    ...postDetails,
                    replies: postDetails.replies.concat([result]),
                });
                setGiphyLink("");
                setReplyMarkdown("");
                showToast("SUCCESS", "Replied to this post!");
                return;
            }
            showToast("ERROR", "Something went wrong!");
        } catch (error) {
            showToast("ERROR", "Something went wrong!");
        }
    };
    if (!postDetails && !link && !mainLoading)
        return (
            <div className="main-container animation-fade-in relative">
                <div className="md:bg-kadItemDarkBg relative shadow-lg mx-auto w-full lg:w-1/2 rounded-lg py-8 flex flex-col items-center">
                    <h2 className="page-title">404</h2>
                    <h4 className="opacity-70 mt-4">This page is lost.</h4>
                    <LinkWithSearchParams
                        to={{
                            pathname: "/",
                        }}
                        className="mt-8 size-1 rounded-full px-4 py-2 font-normal border border-kadComponentBorder hover:bg-kadComponentBorder duration-150 cursor-pointer"
                    >
                        Back to Home
                    </LinkWithSearchParams>
                </div>
            </div>
        );
    return (
        <div className="flex flex-col animation-fade-in gap-4 py-6">
            {mainLoading ? (
                <LoadingBar text="📰 Displaying Post..." />
            ) : (
                postDetails && (
                    <>
                        <div className="flex gap-4">
                            <ProfileBadge profile={postDetails.author} />
                            <div className="flex flex-col">
                                <LinkWithSearchParams
                                    className="hover:opacity-70"
                                    to={{
                                        pathname: `/profile/${postDetails.author?.username}`,
                                    }}
                                >
                                    {postDetails.author?.username ===
                                    postDetails.author?.wallet
                                        ? getEllipsisTxt(
                                              postDetails.author?.username,
                                              4
                                          )
                                        : postDetails.author?.username}
                                </LinkWithSearchParams>
                                <span className="size-sm font-light opacity-70">
                                    {new Date(
                                        postDetails.post.createdAt
                                    ).toLocaleDateString("en-US", {})}
                                    {/* {" · "}
                                    {Math.ceil(
                                        postDetails.post.markdown.length / 1000
                                    )}{" "}
                                    mins read */}
                                </span>
                            </div>
                            {postDetails.author?.followers && (
                                <button
                                    onClick={() =>
                                        followOthersProfile(
                                            postDetails.author?.username
                                        )
                                    }
                                    className="profile-follow "
                                >
                                    {postDetails.author?.followers?.includes(
                                        account
                                    )
                                        ? "Following"
                                        : "Follow"}
                                </button>
                            )}
                            <HiLink
                                title="Copy Link"
                                className="cursor-pointer ml-auto size-1 hover:opacity-70 duration-150"
                                onClick={() => {
                                    navigator.clipboard.writeText(
                                        window.location.href
                                    );
                                }}
                            />
                            <BsFacebook
                                title="Copy Link"
                                className="cursor-pointer size-1 hover:opacity-70 duration-150"
                                onClick={() => {
                                    const shareLink = `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;
                                    window.open(shareLink, "_blank").focus();
                                }}
                            />
                        </div>
                        <span className="text-center relative size-2 md:size-3">
                            {postDetails.post.featured && (
                                <GiChainedHeart
                                    title="Featured Post"
                                    className="text-[100px] mr-4 duration-150 opacity-10 absolute left-1/2 top-1/2 -translate-x-1/2"
                                />
                            )}
                            {postDetails.post.subject}
                        </span>
                        <div className="react-mark-down">
                            <MDEditor.Markdown
                                source={postDetails.post.markdown}
                                style={{
                                    background: "transparent",
                                }}
                            />
                            {postDetails?.post?.giphyLink?.length > 0 && (
                                <img
                                    alt="giphy attachment"
                                    src={postDetails?.post?.giphyLink}
                                    className="animation-enter w-full mt-4"
                                />
                            )}
                        </div>
                        <div className="h-1 bg-kadComponentActive rounded-lg" />
                        <div className="flex flex-col pl-4 lg:pl-8 gap-y-4">
                            {postDetails.replies.map((reply, index) => (
                                <div key={index} className="flex flex-col">
                                    <div className="flex gap-4 items-center pb-2">
                                        {replyAuthor(reply.wallet) && (
                                            <ProfileBadge
                                                profile={replyAuthor(
                                                    reply.wallet
                                                )}
                                            />
                                        )}
                                        <div className="flex flex-col">
                                            <LinkWithSearchParams
                                                className="hover:opacity-70"
                                                to={{
                                                    pathname: `/profile/${
                                                        replyAuthor(
                                                            reply.wallet
                                                        )?.username
                                                    }`,
                                                }}
                                            >
                                                {
                                                    replyAuthor(reply.wallet)
                                                        ?.username
                                                }
                                            </LinkWithSearchParams>
                                            <span className="size-sm font-light opacity-70">
                                                {new Date(
                                                    reply.createdAt
                                                ).toLocaleDateString(
                                                    "en-US",
                                                    {}
                                                )}
                                                {/* {" · "}
                                                {Math.ceil(
                                                    reply.markdown.length / 1000
                                                )}{" "}
                                                mins read */}
                                            </span>
                                        </div>

                                        {replyAuthor(reply.wallet)
                                            ?.followers && (
                                            <button
                                                onClick={() =>
                                                    followOthersProfile(
                                                        replyAuthor(
                                                            reply.wallet
                                                        )?.username
                                                    )
                                                }
                                                className="profile-follow "
                                            >
                                                {replyAuthor(
                                                    reply.wallet
                                                )?.followers?.includes(account)
                                                    ? "Following"
                                                    : "Follow"}
                                            </button>
                                        )}
                                    </div>
                                    <div className="react-mark-down">
                                        <MDEditor.Markdown
                                            source={reply.markdown}
                                            style={{
                                                background: "transparent",
                                            }}
                                        />

                                        {reply?.giphyLink?.length > 0 && (
                                            <img
                                                alt="giphy attachment"
                                                src={reply?.giphyLink}
                                                className="animation-enter w-full mt-4"
                                            />
                                        )}
                                    </div>

                                    <div className="mt-4 h-0.5 bg-kadComponentFocus" />
                                </div>
                            ))}
                            <div className="flex flex-col">
                                <textarea
                                    placeholder="Share your opinion here (up to 100 words)..."
                                    className="preview-article-content border-0 p-0 rounded-none w-full"
                                    value={replyMarkdown}
                                    onChange={(e) =>
                                        setReplyMarkdown(e.target.value)
                                    }
                                />

                                {giphyLink?.length > 0 && (
                                    <div className="relative group">
                                        <div
                                            className="absolute w-full h-full hidden group-hover:flex items-center justify-center bg-kadComponentBg cursor-pointer"
                                            onClick={() => {
                                                setGiphyLink("");
                                            }}
                                        >
                                            <RiDeleteBin2Line className="size-4 p-2 bg-kadDarkBg rounded-lg fill-kadGrSt" />
                                        </div>
                                        <img
                                            alt="giphy attachment"
                                            src={giphyLink}
                                            className="animation-enter w-full"
                                        />
                                    </div>
                                )}
                                <div className="flex items-center justify-end mt-2">
                                    <HoverGiphy
                                        icon={<AiOutlineGif />}
                                        onGifClick={onGifClick}
                                    />
                                    <button
                                        className="blueGradient-button ml-2 size-sm"
                                        onClick={onPostReply}
                                    >
                                        Reply
                                    </button>
                                </div>
                                <div className="mt-2 h-0.5 bg-kadComponentFocus" />
                            </div>
                        </div>
                        <div className="flex items-center gap-2 sticky bottom-4 py-2 px-4 mx-auto size-sm rounded-full bg-kadItemDarkBg shadow-lg">
                            <div className="flex items-center gap-1 pr-2 border-r-2 border-kadComponentBorder">
                                {postDetails.post.likes.includes(account) ? (
                                    <TbHandClick
                                        className="size-2 cursor-pointer hover:fill-transparent fill-kadGrSt duration-150"
                                        onClick={() =>
                                            likeToggleArticle(
                                                postDetails.post._id
                                            )
                                        }
                                    />
                                ) : (
                                    <TbHandFinger
                                        className="size-2 cursor-pointer hover:stroke-kadGrSt duration-150"
                                        onClick={() =>
                                            likeToggleArticle(
                                                postDetails.post._id
                                            )
                                        }
                                    />
                                )}
                                <span>{postDetails.post.likes.length}</span>
                            </div>
                            <div className="flex items-center gap-1">
                                <BiMessageSquareDetail className="ml-auto size-2 cursor-pointer hover:fill-kadGrSt duration-150" />
                                <span>{postDetails.replies.length}</span>
                            </div>
                        </div>
                    </>
                )
            )}
        </div>
    );
};
export default ViewPost;
